<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8 pt-4 pb-12">
    <div class="flex flex-row px-4 justify-center mt-6 space-x-4 ">
      <ScheduleDate
        dayOfWeek="Day One"
        day="9"
        :selected="selectedIndex === 0"
        @click="selectIndex(0)"
      ></ScheduleDate>
      <div class="bg-lightFont" style="width: 2px"></div>
      <ScheduleDate
        dayOfWeek="Day Two"
        day="10"
        :selected="selectedIndex === 1"
        @click="selectIndex(1)"
      ></ScheduleDate>
    </div>
    <div></div>
    <div class="mt-12 space-y-14">
      <div v-for="session in currentSessions" :key="session._id">
        <session-schedule-block :session="session" />
      </div>
    </div>
  </div>
</template>
<script>
import { sanityClient } from "../utils/sanity";
import SessionScheduleBlock from "../components/SessionScheduleBlock.vue";
import { auth, remindersCollection, db } from "../utils/firebase";
import { mapGetters } from "vuex";
import ScheduleDate from "../components/schedule/ScheduleDate";

export default {
  components: {
    ScheduleDate,
    SessionScheduleBlock
  },
  data() {
    return {
      sessions: [],
      groupedSessions: null,
      dates: [],
      selectedIndex: 0,
      subscription: null,
      unsubscribeReminder: null,
      subscribedAll: false
    };
  },
  mounted() {},
  methods: {
    remindAll() {
      const batch = db.batch();
      this.sessions.map(session => {
        if (!session.slug) {
          console.warn(`Missing slug for session ${session._id}`);
          return;
        }
        const reminder = {
          user: auth.currentUser.uid,
          emailAddress: auth.currentUser.email,
          sessionSlug: session.slug.current
        };
        let newReminderRef = remindersCollection.doc();
        batch.set(newReminderRef, reminder);
      });

      batch
        .commit()
        .then(() => {
          this.$store.dispatch(
            "setFlashMessage",
            "Thanks for subscribing. You'll be sent an email when sessions begin"
          );
        })
        .catch(err => {
          console.warn(err);
          this.$store.dispatch(
            "setFlashMessage",
            "An error occured and we couldn't set up reminders"
          );
        });
    },
    selectIndex(index) {
      this.selectedIndex = index;
    },
    subscribe() {
      // Sanity's listeners will listen to all changes to the returned docs
      // It does NOT listen to all changes to a query. Just an FYI
      const queryString =
        "*[_type == 'session' && !(_id in path('drafts.**'))]{_id}";
      return sanityClient
        .listen(queryString, {}, { includeResult: false, visibility: "query" })
        .subscribe(() => {
          this.fetchSessions();
        });
    },
    fetchSessions() {
      const queryString =
        "*[_type == 'session' && !(_id in path('drafts.**'))] | order(startTime asc) {productCompatibility[]->{...}, ...}";
      sanityClient
        .fetch(queryString)
        .then(res => {
          this.sessions = res;
          const sessionDates = [];
          const groups = res.reduce((groups, session) => {
            const date = new Date(session.startTime).toLocaleDateString();
            if (!groups[date]) {
              groups[date] = [];
              sessionDates.push(date);
            }
            groups[date].push(session);
            return groups;
          }, {});

          this.dates = sessionDates;
          this.groupedSessions = groups;

          const currentDate = new Date().toLocaleDateString();
          const index = this.dates.findIndex(d => d === currentDate);
          // if (index > -1) {
          //   this.selectedIndex = index;
          // }
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  },
  created() {
    this.fetchSessions();
    // this.subscription = this.subscribe();
    if (auth.currentUser) {
      this.unsubscribeReminder = remindersCollection
        .where("user", "==", auth.currentUser.uid)
        .onSnapshot(querySnapshot => {
          this.subscribedAll = querySnapshot.docs.length >= 18;
        });
    }
  },
  beforeDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.unsubscribeReminder) {
      this.unsubscribeReminder();
    }
  },
  computed: {
    ...mapGetters(["loggedIn"]),
    currentSessions() {
      const currentIndex = this.selectedIndex;
      if (this.dates.length > 0 && this.groupedSessions) {
        const currentDate = this.dates[currentIndex];
        return this.groupedSessions[currentDate];
      }
      return [];
    }
  }
};
</script>
